import { siteConfig } from '../../config/site'
import { carrierPickupTimes, storeHours } from '../../data'
import type { CarrierId } from '../../data'

interface StoreInfoPanelProps {
  carrierId?: CarrierId
}

export function StoreInfoPanel({ carrierId }: StoreInfoPanelProps) {
  const pickup = carrierId
    ? carrierPickupTimes.find(({ carrierId: pickupCarrierId }) => pickupCarrierId === carrierId)
    : undefined

  return (
    <aside className="store-info-panel" aria-label="Pack Print Mail store information">
      <div>
        <h2>Pack Print Mail</h2>
        <address>{siteConfig.address.formatted}</address>
        <a href={siteConfig.phoneHref}>{siteConfig.phone}</a>
        <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
        {pickup ? <p className="store-info-panel__pickup"><strong>Carrier pickup:</strong> {pickup.note}</p> : null}
      </div>
      <div>
        <h2>Store Hours</h2>
        <dl>
          {storeHours.map((entry) => (
            <div key={entry.label}>
              <dt>{entry.label}</dt>
              <dd>{entry.display}</dd>
            </div>
          ))}
        </dl>
      </div>
    </aside>
  )
}
